















































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { UpdateUserInfoRole,QueryMemberAllList,QueryPartnerAllList} from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VTable, TableHander } from '@/components/table'
import { VImageUpload } from '@/components/upload'
import { TxLocal } from '@/utils/local/TxLocal'
import constant from '@/utils/constant'

@Component({
  components: {
    VTable,
    VImageUpload,
  },
})
export default class UpdateUserInfoRoleDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    // 重置数据
    this.data = {
      type: 1,
      memberId: null,
      partnerId: null,
      userType: 0,
      userLocation: null,
      teamType: 0
    }
    this.show = false
  }
  private data: any = {
    type:1,
    memberId:null,
    partnerId:null,
    userType:0,
    userLocation:null,
    teamType:0
  }
  private show = false
  private isEdit = false
  private memberList: Array<any> = []
  private partnerList: Array<any> = []



  public async open(data: any, isEdit: boolean) {
    this.show = true
    this.isEdit = isEdit
    QueryMemberAllList().then(res=>{
      this.memberList = res
    })
     QueryPartnerAllList().then(res=>{
      this.partnerList = res
    })
    
    // 设置用户ID
    this.data.userId = data.id;
    
    // 判断身份类型
    if (data.memberId) {
      this.data.type = 2; // 会员
      this.data.memberId = data.memberId;
      this.data.partnerId = null;
    } else if (data.partnerId) {
      this.data.type = 1; // 合伙人
      this.data.partnerId = data.partnerId;
      this.data.memberId = null;
    } else {
      this.data.type = 1; // 默认合伙人
      this.data.memberId = null;
      this.data.partnerId = null;
    }
    
    // 设置用户类型和位置（确保返显）
    this.data.userType = data.userType !== undefined && data.userType !== null ? data.userType : 0;
    this.data.userLocation = data.userLocation || '';
    // 设置战队类型
    this.data.teamType = data.teamType !== undefined && data.teamType !== null ? data.teamType : 0;
  }

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    type: [this.requiredRule],
  }


  public async save() {

    const form = this.$refs.form as ElForm
    form.validate(async (valid: boolean) => {
      if (valid) {
        let result = {}
        if(this.isEdit){
          result = await UpdateUserInfoRole(this.data)
        }
        if(result){
          this.close()
        }

      } else {
        this.$message.error("表单存在错误，不能保存")
        return false
      }
    })
  }
}
